const navigationElement = document.querySelector('.js-mobile-nav');
const navigationAnchorElements = document.querySelectorAll('.js-nav-link');
const navigationToggleButtons = document.querySelectorAll('.js-nav-toggle');

let isMobileNavigationOpen = navigationElement.classList.contains('is-active');
let scrollPositionY = 0;

const openNavigation = () => {
  isMobileNavigationOpen = true;
  scrollPositionY = document.documentElement.scrollTop;
  if (navigationElement) {
    navigationElement.classList.add('is-active');
  }
};

const closeNavigation = () => {
  isMobileNavigationOpen = false;
  window.scrollTo(0, scrollPositionY);
  if (navigationElement) {
    navigationElement.classList.remove('is-active');
  }
};

navigationAnchorElements.forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    closeNavigation();
  });
});

navigationToggleButtons.forEach((button) => {
  button.addEventListener('click', (e) => {
    document.documentElement.classList.toggle('is-fixed');

    if (isMobileNavigationOpen) {
      return closeNavigation();
    }

    openNavigation();
  });
});

const navbarMenu = document.getElementById('navbar-language-login');
if (navbarMenu) {
  const loginActions = document.querySelectorAll('.login-action');
  loginActions.forEach((el) => {
    el.addEventListener('click', () => {
      navbarMenu.classList.add('login-open');
    })
  })

  window.addEventListener('click', (e) => {
    if (!e.target.parentNode ||
      !e.target.parentNode.parentNode ||
      !e.target.parentNode.parentNode.classList.contains('login-action'))
    {
      navbarMenu.classList.remove('login-open');
    }
  })
}
